import React from 'react'
import { render } from 'react-dom'

import TenantPayOnlineForm from '../../../components/Billing/TenantPayOnlineForm'
import { browserHistory } from 'react-router'

export default React.createClass({
    render(){
        return (
            <div>
                <div class="row">
                    <div class="col-md-1">
                        <span class="go-back go-back-left-side" onClick={browserHistory.goBack}><i class="icon-arrow-left"></i></span>
                    </div>
                </div>
                <TenantPayOnlineForm />
            </div>
        )
    }
});


// WEBPACK FOOTER //
// app/views/Tenant/PaymentForm/index.js